import { Button, Modal, Steps } from 'antd'
import React, { useEffect, useState } from 'react'
import './ImportDataModal.scss'
import ImportDataStep1 from './Step1V1'
import ImportDataStep2 from './Step2V1'
import ImportDataStep3 from './Step3V1'
import ImportDataStep4 from './Step4V1'
import { mixPostV2 } from '../../../../services/mixin'
import useToast from '../../../../hook/useToast';
import * as XLSX from "xlsx";
import { PlusOutlined } from '@ant-design/icons'
import CreateSystemParamModal from '../../../../components/SyncData/CreateSystemParamModalV2'
import ImportDataPreviewStep from './PreviewStep'

interface Props {
  show: boolean
  modalClose?: () => void
  columns?: any,
  source?: any
  paramKeysChange?: () => void,
  paramMap?: any,
  paramMapChange?: () => void,
}

const ImportDataModal: React.FC<Props> = (props) => {
  const { show, modalClose, columns, source, paramKeysChange, paramMap, paramMapChange } = props
  const pushToast = useToast();
  const [currentStep, setCurrentStep] = useState(0)
  const [listFiles, setListFiles] = useState([] as any)
  const [iswait, setIswait] = useState(true)
  const [showParamModal, setShowParamModal] = useState(false)
  const [sourceId, setSourceId] = useState(null)

  const importFile = async () => {
    const param = {} as any
    const temp = [] as any
    const tempParamMap = JSON.parse(JSON.stringify(paramMap)) as any

    Object.keys(fileData).map((iskey: any, index: any) => {
      const data = [] as any
      fileData[iskey].headers.map((val2: any, index2: any) => {
        if (fileData[iskey].obhead[val2].newField) {
          const col = columns.find((x: any) => x.column === fileData[iskey].obhead[val2].newField);
          data.push({
            position: index2,
            key: fileData[iskey].obhead[val2].newField,
            type: col ? col.type : fileData[iskey].obhead[val2].type,
            label: fileData[iskey].obhead[val2].label
          })

          tempParamMap.forEach((item: any) => {
            if (Array.isArray(item.data)) {
              item.data = item.data.filter((text: any) => text !== fileData[iskey].obhead[val2].label);
            }
          });
          const findData = tempParamMap.find((x: any) => x.column === fileData[iskey].obhead[val2].newField)
          if (findData) {
            if (Array.isArray(findData.data)) {
              if (!findData.data.includes(fileData[iskey].obhead[val2].label)) {
                findData.data.push(fileData[iskey].obhead[val2].label);
              }
            } else {
              findData.data = [fileData[iskey].obhead[val2].label];
            }
          } else {
            tempParamMap.push({
              column: fileData[iskey].obhead[val2].newField,
              data: [fileData[iskey].obhead[val2].label],
              source_id: sourceId,
            })
          }
        }
        return true
      })
      temp.push({
        name_file: `file_${index + 1}`,
        source_id: fileData[iskey].source,
        data
      })
      param[`file_${index + 1}`] = fileData[iskey].tempFile
      param.user_id_thaco = 1
      return true
    })
    param.params = JSON.stringify(temp)
    const res = await mixPostV2('/api/v1/be/warehouse/import_file_v2', param)
    setIswait(false)
    if (res.status) {
      savePramMap(tempParamMap)
    }
    return
    // const temp = listFiles
    // if (temp[index]) {
    //   const param = {
    //     file: temp[index].temp
    //   }
    //   temp[index].status = 2
    //   const res = await mixPostV2('/api/v1/be/warehouse/import_file_v2', param)
    //   temp[index].res = res
    //   if (res.status) {
    //     temp[index].status = 3
    //   } else {
    //     temp[index].status = 4
    //   }
    //   const next = index + 1
    //   setListFiles([...temp])
    //   importFile(next)
    // } else {
    //   return
    // }
  }
  const savePramMap = async (data: any) => {
    const res = await mixPostV2('/api/v1/be/setting_mapping', {
      value: JSON.stringify(data),
      type: 2,
    })
    if (res.status) {
      if (paramMapChange) {
        paramMapChange()
      }
    }
  }
  const startImport = () => {
    // if (listFiles.length === 0) {
    //   pushToast("Vui lòng chọn file!", "warning")
    //   return
    // }
    // importFile(0)
    // setCurrentStep(3)
  }

  // read file
  const [keys, setKeys] = useState<string[]>([]);
  const [firstRow, setFirstRow] = useState<Record<string, any>>({});
  const [fileData, setFileData] = useState({} as any)
  useEffect(() => {
    setFileData({})
  }, [show])

  const excelDateToString = (serial: number): string => {
    // Số serial hợp lệ của Excel thường lớn hơn 25569 (tương ứng 1/1/1970)
    if (typeof serial !== "number" || serial < 25569 || serial > 60000) return serial as unknown as string;
    const utc_days = Math.floor(serial - 25569);
    const utc_value = utc_days * 86400;
    const date_info = new Date(utc_value * 1000);
    // Định dạng dd/mm/yyyy
    return date_info.getDate().toString().padStart(2, '0') + '/' +
      (date_info.getMonth() + 1).toString().padStart(2, '0') + '/' +
      date_info.getFullYear();
  };

  const handleFileUpload = async (
    files: FileList
  ): Promise<
    { fileName: string; headers: string[]; firstRowData: Record<string, any>; allRowData: Record<string, any>[] }[]
  > => {
    const processFile = (file: File): Promise<{
      fileName: string;
      headers: string[];
      firstRowData: Record<string, any>;
      allRowData: Record<string, any>[];
      tempFile: any;
    }> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = (e) => {
          const arrayBuffer = e.target?.result;
          if (!arrayBuffer) {
            reject(new Error("Failed to read file"));
            return;
          }

          try {
            const data = new Uint8Array(arrayBuffer as ArrayBuffer);
            const workbook = XLSX.read(data, { type: "array" });
            const firstSheetName = workbook.SheetNames[0];
            const firstSheet = workbook.Sheets[firstSheetName];

            // Chuyển đổi sheet thành JSON
            const jsonData = XLSX.utils.sheet_to_json(firstSheet, { header: 1 });

            if (jsonData.length > 0) {
              const headers = jsonData[0] as string[];
              const allRowData = jsonData.slice(1).map((row: any) =>
                headers.reduce((obj, key, index) => {
                  let value = row[index] || null;
                  // Xử lý nếu value là số (có thể là số serial ngày tháng của Excel)
                  if (
                    typeof value === "number" &&
                    key.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes("ngay")
                  ) {
                    value = excelDateToString(value);
                  }
                  obj[key] = value;
                  return obj;
                }, {} as Record<string, any>)
              );
              const firstRowData = allRowData[0] || {};

              resolve({ fileName: file.name, headers, firstRowData, allRowData, tempFile: file });
            } else {
              resolve({ fileName: file.name, headers: [], firstRowData: {}, allRowData: [], tempFile: file });
            }
          } catch (error) {
            reject(error);
          }
        };

        reader.onerror = () => {
          reject(new Error("Error reading file"));
        };

        reader.readAsArrayBuffer(file);
      });
    };

    // Xử lý tất cả các file
    const results = await Promise.all(Array.from(files).map(processFile));
    return results
  };

  const filesChange = async (e: any) => {
    // setListFiles(e)
    const files = [] as any
    e.map((val: any) => {
      files.push(val.temp)
      return true
    })
    const results = await handleFileUpload(files)
    const temp = {} as any
    results.map((val: any) => {
      const obhead = {} as any
      val.headers.map((valHead: any) => {
        obhead[valHead] = {
          oriField: valHead,
          newField: null,
          type: null,
          label: null,
        }
        return true
      })
      temp[val.fileName] = {
        ...val,
        obhead,
        source: null,

      }
      return true
    })
    setFileData({ ...temp })
    return
  }
  const colChange = (data: any) => {
    if (data.type === 1) {
      const sourceParamMap = paramMap
      fileData[data.fileName].source = data.e
      Object.keys(fileData[data.fileName].obhead).map((iskey: any) => {
        let item = {
          ...fileData[data.fileName].obhead[iskey],
          newField: null,
          type: null,
          label: null,
        }
        if (sourceParamMap) {
          const findData = sourceParamMap.find((x: any) => x.data && x.data.includes(iskey))
          if (findData) {
            const col = columns.find((x: any) => x.column === findData.column)
            item.newField = findData.column
            item.label = iskey
            item.type = col.type_id
          }
        }
        fileData[data.fileName].obhead[iskey] = item
      })

      setFileData({ ...fileData })
    } else {
      if (data.e) {
        const findData = columns.find((x: any) => x.column === data.e)
        fileData[data.fileName].obhead[data.val] = {
          ...fileData[data.fileName].obhead[data.val],
          newField: data.e,
          type: findData.type_id,
          label: data.val
        }
        setFileData({ ...fileData })
      } else {
        fileData[data.fileName].obhead[data.val] = {
          ...fileData[data.fileName].obhead[data.val],
          newField: null,
          type: null,
          label: null,
        }
        setFileData({ ...fileData })
      }
    }
  }

  const colChangeV2 = () => {
    const sourceParamMap = paramMap
    Object.keys(fileData).map((nameFile: any) => {
      fileData[nameFile].source = null
      Object.keys(fileData[nameFile].obhead).map((iskey: any) => {
        if (iskey === 'customer_code') {
          const findDatax = sourceParamMap.find((x: any) => x.data && x.data.includes(iskey))
        }
        let item = {
          ...fileData[nameFile].obhead[iskey],
          newField: null,
          type: null,
          label: null,
        }
        if (sourceParamMap) {
          const findData = sourceParamMap.find((x: any) => x.data && x.data.includes(iskey))
          if (findData) {
            const col = columns.find((x: any) => x.column === findData.column)
            if (col) {
              item.newField = findData.column
              item.label = iskey
              item.type = col.type_id
            }
          }
        }
        fileData[nameFile].obhead[iskey] = item
      })
    })

    setFileData({ ...fileData })
  }

  const stepChange = () => {
    Object.keys(fileData).forEach((key) => {
      fileData[key].source = null;
    });
    setFileData({ ...fileData });
  }

  useEffect(() => {
    if (currentStep === 1) {
      stepChange()
    }
  }, [currentStep])

  return (
    <>
      <Modal
        open={show}
        title='Chọn hệ thống và nhập dữ liệu'
        className='rs-modal w-824 import-data-modal'
        maskClosable={false}
        keyboard={false}
        centered
        footer={() => (
          <>
            {
              currentStep === 0 && (
                <>
                  <Button
                    className="rs-button"
                    onClick={modalClose}
                  >Hủy</Button>
                  <Button
                    type="primary"
                    className="rs-button"
                    onClick={() => {
                      if (Object.keys(fileData).length === 0) {
                        pushToast('Vui lòng chọn file', "warning")
                      } else {
                        colChangeV2()
                        setCurrentStep(1)
                      }
                    }}
                  >Tiếp theo</Button>
                </>
              )
            }
            {
              (currentStep === 1) && (
                <>
                  {/* <Button
                    icon={<PlusOutlined />}
                    type="primary"
                    className="rs-button primary-outline mie-auto"
                    onClick={() => {
                      setShowParamModal(true)
                    }}
                  >Tạo param mới</Button> */}
                  <Button
                    className="rs-button"
                    onClick={() => {
                      // setCurrentStep(currentStep - 1)
                      setCurrentStep(0)
                    }}
                  >Quay lại</Button>
                  <Button
                    type="primary"
                    className="rs-button"
                    onClick={() => {
                      const colRequired = columns.filter((x: any) => x.is_required === 1)
                      const listError = [] as any
                      Object.keys(fileData).map((iskey: any) => {
                        const obhead = fileData[iskey].obhead
                        const listNewField = [] as any
                        Object.keys(obhead).map((val: any) => {
                          if (obhead[val].newField) {
                            listNewField.push(obhead[val].newField)
                          }
                          return true
                        })
                        colRequired.map((val: any, index: any) => {
                          if (!listNewField.includes(val.column)) {
                            listError.push({
                              fileName: fileData[iskey].fileName,
                              column: val.column,
                              name: val.name
                            })
                          }
                        })
                        return true
                      })
                      if (listError.length > 0) {
                        pushToast(`${listError[0].fileName} chưa chọn ${listError[0].name}`, "warning")
                        return
                      }
                      setCurrentStep(2)
                    }}
                  >Tiếp theo</Button>
                </>
              )
            }
            {
              (currentStep === 2) && (
                <>
                  <Button
                    className="rs-button"
                    onClick={() => {
                      // setCurrentStep(currentStep - 1)
                      setCurrentStep((current) => current - 1)
                    }}
                  >Quay lại</Button>
                  <Button
                    type="primary"
                    className="rs-button"
                    onClick={() => {
                      importFile()
                      setCurrentStep(3)
                    }}
                  >Tiếp theo</Button>
                </>
              )
            }
            {
              currentStep === 3 && (
                <>
                  <Button
                    className="rs-button"
                    onClick={() => {
                      setCurrentStep(0)
                      setListFiles([])
                      setIswait(true)
                      setFileData({})
                      if (paramMapChange) {
                        paramMapChange()
                      }
                    }}
                  >Import thêm</Button>
                  <Button
                    type="primary"
                    className="rs-button"
                    onClick={() => {
                      if (modalClose) {
                        modalClose()
                      }
                      if (paramMapChange) {
                        paramMapChange()
                      }
                    }}
                  >Đóng</Button>
                </>
              )
            }
          </>
        )}
        onCancel={modalClose}
        afterClose={() => setCurrentStep(0)}
      >
        <Steps
          current={currentStep}
          type="navigation"
          items={[
            {
              title: 'Tải file excel',
            },
            // {
            //   title: 'Kiểm tra trùng lặp',
            // },
            {
              title: 'Thiết lập dữ liệu',
            },
            {
              title: 'Xem trước dữ liệu',
            },
            {
              title: 'Kết quả',
            },
          ]}
          className='rs-steps'
        />

        <div className="import-data-modal-content">
          {
            currentStep === 0 && <ImportDataStep1 fileData={fileData} listFilesChange={(e) => filesChange(e)} />
          }
          {/* {
            currentStep === 1 && <ImportDataStep2 />
          } */}
          {
            currentStep === 1 && <ImportDataStep3
              source={source}
              colChange={(data) => colChange(data)}
              setShowParamModal={(data) => {
                setSourceId(data.source)
                setShowParamModal(true)
              }}
              fileData={fileData}
              columns={columns}
            />
          }
          {
            currentStep === 2 && <ImportDataPreviewStep fileData={fileData} />
          }
          {
            currentStep === 3 && <ImportDataStep4 listFiles={listFiles} fileData={fileData} iswait={iswait} />
          }
        </div>
      </Modal>

      <CreateSystemParamModal
        show={showParamModal}
        source={source}
        sourceId={sourceId}
        hideStatus={true}
        modalClose={() => setShowParamModal(false)}
        onSubmitted={() => {
          setShowParamModal(false)
          if (paramKeysChange) {
            paramKeysChange()
          }
        }}
      />
    </>
  )
}

export default ImportDataModal
